import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Star, Quote, ChevronLeft, ChevronRight } from "lucide-react";
import { REVIEWS } from "@/data/site";
import { Reveal } from "@/components/Reveal";

export default function Reviews() {
  const [i, setI] = useState(0);
  const perView = 3;
  const next = () => setI((p) => (p + 1) % REVIEWS.length);
  const prev = () => setI((p) => (p - 1 + REVIEWS.length) % REVIEWS.length);

  useEffect(() => {
    const t = setInterval(next, 5000);
    return () => clearInterval(t);
  }, []);

  const visible = Array.from({ length: perView }).map((_, k) => REVIEWS[(i + k) % REVIEWS.length]);

  return (
    <section className="bg-soft-grey py-24 md:py-32" data-testid="reviews">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
            <div>
              <span className="text-royal text-xs font-semibold tracking-[0.3em] uppercase">Verified Reviews</span>
              <h2 className="font-display text-4xl md:text-5xl font-extrabold text-navy-deep mt-3">Loved Across Jaipur</h2>
              <div className="flex items-center gap-3 mt-4">
                <div className="flex">{[...Array(5)].map((_, x) => <Star key={x} className="h-5 w-5 fill-gold text-gold" />)}</div>
                <span className="font-display font-bold text-navy-deep text-lg">4.9</span>
                <span className="text-slate-500 text-sm">from 500+ Google reviews</span>
              </div>
            </div>
            <div className="flex gap-2">
              <button onClick={prev} aria-label="Previous" data-testid="review-prev" className="h-11 w-11 rounded-full border border-slate-300 flex items-center justify-center hover:bg-navy-deep hover:text-white transition-colors"><ChevronLeft className="h-5 w-5" /></button>
              <button onClick={next} aria-label="Next" data-testid="review-next" className="h-11 w-11 rounded-full border border-slate-300 flex items-center justify-center hover:bg-navy-deep hover:text-white transition-colors"><ChevronRight className="h-5 w-5" /></button>
            </div>
          </div>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-6">
          <AnimatePresence mode="popLayout">
            {visible.map((r, k) => (
              <motion.div
                key={r.name + i}
                initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }} transition={{ duration: 0.4, delay: k * 0.08 }}
                className="bg-white rounded-lg p-7 border border-slate-200 shadow-sm relative"
              >
                <Quote className="h-8 w-8 text-royal/15 absolute top-5 right-5" />
                <div className="flex mb-3">{[...Array(r.rating)].map((_, x) => <Star key={x} className="h-4 w-4 fill-gold text-gold" />)}</div>
                <p className="text-slate-700 text-sm leading-relaxed min-h-[96px]">{r.text}</p>
                <div className="flex items-center gap-3 mt-5 pt-5 border-t border-slate-100">
                  <div className="h-11 w-11 rounded-full bg-gradient-to-br from-royal to-navy flex items-center justify-center text-white font-bold text-sm">{r.initials}</div>
                  <div>
                    <div className="font-semibold text-navy-deep text-sm">{r.name}</div>
                    <div className="text-xs text-slate-500">{r.area}, Jaipur</div>
                  </div>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
}
